import React, { ReactElement, useEffect, useState } from 'react';
import ModalContainer from 'components/molecules/ModalContainer';
import { Typography, Grid, Button, CircularProgress } from '@material-ui/core';
import useWarehouseIM from 'hooks/useWarehouseIM';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { IWareHouseList } from 'interfaces/imWarehouse.interface';

interface Props {
  open: boolean;
  warehouseId: string;
  onClose(): void;
  getAllWarehouses(): void;
}

export default function IMWarehouseDelete({ open, onClose, warehouseId, getAllWarehouses }: Props): ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [warehouseToDelete, setPackageToDelete] = useState<IWareHouseList>();
  const { getWarehouseById, deleteWarehouse } = useWarehouseIM();
  const { showNotistack } = useCustomSnackbar();

  useEffect(() => {
    if (warehouseId) {
      setIsLoading(true);
      getWarehouseById(warehouseId)
        .then((resultPackage: IWareHouseList) => {
          setPackageToDelete(resultPackage);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [warehouseId]);

  const handleOnClick = () => {
    deleteWarehouse(warehouseId).then((response) => {
      if (response === true) {
        showNotistack({ message: 'La bodega se eliminó correctamente' });
        getAllWarehouses();
        onClose();
      } else {
        showNotistack({ message: 'Ocurrió un error al eliminar el bodega' });
      }
    });
  };
  return (
    <ModalContainer open={open} title="Eliminar bodega">
      <Grid container justify="center" alignItems="center">
        <Typography variant="h5">{`Estas seguro que deseas eliminar el registro: '${warehouseToDelete?.name}'?`}</Typography>
      </Grid>
      <Grid container justify="center">
        <Button
          onClick={handleOnClick}
          variant="contained"
          color="primary"
          disabled={isLoading}
          style={{ marginTop: 20 }}
        >
          {isLoading ? <CircularProgress size={24} /> : ''} Aceptar
        </Button>
        <Button
          variant="contained"
          color="default"
          disabled={isLoading}
          style={{ marginTop: 20, marginLeft: 20 }}
          onClick={onClose}
        >
          {isLoading ? <CircularProgress size={24} /> : ''} Cancelar
        </Button>
      </Grid>
    </ModalContainer>
  );
}
